// Imports
import { Base, DataTypes, SubmitTypes, ErrorTypes } from '@mixins/forms'
import { getDateOrValue } from '@utils/date-helpers'

// Parts
const { ObjectDataType: dataType } = DataTypes
const { ReturnSubmit: submitType } = SubmitTypes
const { DummyError: errorHandling } = ErrorTypes

// Options
const options = {
  name: 'filtering-form',
  dataType,
  submitType,
  errorHandling,
  submitOnChange: true,
  skipValidation: true,
}

/**
* Filtering Form
* @description - 
*/
export default {
  name: options.name,
  mixins: [
    Base(options)
  ],
  props: {
    submitOnChangeOveride: Boolean,
    skipValidationOveride: Boolean
  },
  methods: {
    /**
    * Transforms the data before passing it
    * to the submit action.
    */
    async transformData() {
      const data = {}
      this.inputs.forEach((inputObj) => {
        const value = this.updateFilter(inputObj.name, inputObj.getValue(), inputObj.el)
        if (value) {
          data[inputObj.name] = value
        } else {
          delete data[inputObj.name]
        }
      })
      this.$logger.debug('transformData: ', data)
      this.$emit('raw-data', data)
      return data
    },
    updateFilter(name, value, el) {
      let newValue = getDateOrValue(value)
      console.log(newValue)
      if (el.data('filter-also')) {
        newValue = {
          $or: [
            { [name]: newValue },
            ...el.data('filter-also')
              .split(',')
              .map(key => {
                return {
                  [key]: newValue
                }
              })
          ]
        }
      } else if (el.data('filter-daterange')) {
        const names = el.data('filter-daterange').split(':')
        newValue = {
          $and: [
            { [names[0]]: {
              $lte: getDateOrValue(newValue.split(' - ')[0])
            } },
            { [names[1]]: {
              $gte: getDateOrValue(newValue.split(' - ')[1])
            } }
          ]
        }
      } else if (el.data('filter-or')) {
        newValue = {
          $or: [
            { [name]: newValue }
          ]
        }
      }
      if (!value) {
        return null
      } else {
        return newValue
      }
    },
    /**
    * Transforms the response before passing it
    * to the final action.
    */
    async transformResponse(response) {
      const transformedFilter = {}
      const values = Object.values(response)
      const keys = Object.keys(response)
      keys.forEach((key, i) => {
        const value = values[i]
        if (value.$and) {
          this.conditionAndFilter(transformedFilter, value)
        } else if (value.$or) {
          this.conditionOrFilter(transformedFilter, value)
        } else {
          this.commonFilter(transformedFilter, value, key)
        }
      })
      this.$logger.debug('transformResponse: ', transformedFilter)
      return transformedFilter
    },
    // Filter types
    initiateFilter(filter = {}) {
      if (!filter.$and) {
        filter.$and = []
      }
    },
    commonFilter(filter, value, key) {
      this.initiateFilter(filter)
      filter.$and.push({ [key]: value })
    },
    conditionOrFilter(filter, value) {
      this.initiateFilter(filter)
      const createdOr = filter.$and.filter(item => !!item.$or)[0]
      if (createdOr) {
        createdOr.$or = {
          ...createdOr.$or,
          ...value.$or
        }
      } else {
        filter.$and.push({ $or: value.$or })
      }
    },
    conditionAndFilter(filter, value) {
      this.initiateFilter(filter)
      filter.$and = [
        ...filter.$and,
        ...value.$and
      ]
    },
  }
}